import React from 'react';
import { Modal } from 'react-bootstrap';
import swal from 'sweetalert';
import i18n from '../../../../../i18n';
import { deductFund } from '../../../../../models/auctionDelivery';

export class AuctionFundDeductModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      input: {},
      errors: {},
      fileInputs: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      input: { ...prevState.input, [name]: value },
    }));
  };

  validateOfflineForm = () => {
    const required = ['withdraw_amount'];

    for (let field of required) {
      if (!this.state.input[field]) {
        return false;
      }
    }
  };

  async handleSubmit(event) {
    // const { input } = this.state;
    const { auction } = this.props;
    event.preventDefault();

    // const isValidOffline = this.validateOfflineForm();

    // if (!isValidOffline) {
    //   swal(i18n.t('failed'), i18n.t('all_mandatory'), 'error');
    //   return;
    // }

    try {
      this.setState({ loading: true });
      const payload = {
        debit: auction?.total_amount || 0,
        auction: auction.id,
        group: auction.group_id,
        user: auction.user_id,
      };

      const response = await deductFund(payload);
      if (response && response.success) {
        swal(i18n.t('success'), i18n.t('fund_added'), 'success');
        this.setState({ loading: false });
        if (this.props.onSuccess) {
          this.props.onSuccess();
        } else {
          this.props.onClose();
        }
      } else {
        swal(i18n.t('failed'), response.message, 'error');
        this.setState({ loading: false });
      }
    } catch (err) {
      console.log(err);
      this.setState({ loading: false });
    }
  }

  render() {
    const { show, onClose, auction } = this.props;
    const { loading, errors } = this.state;
    return (
      <Modal
        show={show}
        onHide={onClose}
        size="lg"
        dialogClassName="wallet-modal-dialog"
        className="wallet-fund-modal"
      >
        <Modal.Header closeButton className="wallet-modal-header">
          <Modal.Title className="wallet-modal-title">
            <i className="fa fa-wallet mr-2"></i>
            {i18n.t('fund_deduct')}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="wallet-modal-body">
          {/* Form Content */}
          <div className="wallet-form-container">
            <div className="stats-section-center">
              <div className="stat-box-center">
                <div className="stat-label-center">Wallet</div>
                <div className="stat-value-center">{auction?.wallet_amount || 0} SAR</div>
              </div>

              <div className="stat-box">
                <div className="stat-label-center">Client</div>
                <div className="stat-value-center amount">{auction?.client_amount || 0} SAR</div>
              </div>
            </div>
            <form className="wallet-form" autoComplete="off">
              <div className="wallet-form-content">
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="wallet-form-label">{i18n.t('actual_total')}</label>
                    <input
                      type="text"
                      name="actual_total"
                      value={auction?.total_amount || 0}
                      onChange={this.handleChange}
                      className="wallet-form-input"
                      disabled
                      placeholder={auction?.total_amount}
                    />
                    <div className="wallet-error">{errors.actual_total}</div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="wallet-form-label">{i18n.t('total_amount')}</label>
                    <input
                      type="text"
                      name="total_amount"
                      value={auction?.total_amount || 0}
                      onChange={this.handleChange}
                      className="wallet-form-input"
                      disabled
                      placeholder={auction?.total_amount}
                    />
                    <div className="wallet-error">{errors.total_amount}</div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="wallet-form-label">{i18n.t('paid_amount')}</label>
                    <input
                      type="text"
                      name="paid_amount"
                      value={0}
                      onChange={this.handleChange}
                      className="wallet-form-input"
                      disabled
                      placeholder={auction?.total_amount}
                    />
                    <div className="wallet-error">{errors.paid_amount}</div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="wallet-form-label">{i18n.t('withdraw_amount')}</label>
                    <input
                      type="text"
                      name="withdraw_amount"
                      value={auction?.total_amount || 0}
                      onChange={this.handleChange}
                      className="wallet-form-input"
                      disabled
                      placeholder={auction?.total_amount}
                    />
                    <div className="wallet-error">{errors.withdraw_amount}</div>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="wallet-actions">
                <button type="button" className="wallet-btn wallet-btn-cancel" onClick={onClose}>
                  {i18n.t('cancel')}
                </button>
                <button
                  type="button"
                  className="wallet-btn wallet-btn-submit"
                  onClick={this.handleSubmit}
                  disabled={loading || auction?.client_amount < auction?.total_amount}
                >
                  {loading && <i className="fa fa-spinner fa-spin mr-2"></i>}
                  {i18n.t('deduct')}
                </button>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}
